import { render, staticRenderFns } from "./ActivityTextButton.vue?vue&type=template&id=31e4bece&scoped=true"
import script from "./ActivityTextButton.vue?vue&type=script&lang=ts"
export * from "./ActivityTextButton.vue?vue&type=script&lang=ts"
import style0 from "./ActivityTextButton.vue?vue&type=style&index=0&id=31e4bece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4bece",
  null
  
)

/* custom blocks */
import block0 from "./ActivityTextButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports